/**
 * TanStack Query hooks for `dynamic-commission-by-order-value-aov`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	dynamicCommissionByOrderValueAovQueryKeys,
	type CreateDynamicCommissionByOrderValueAovBody,
	type ListDynamicCommissionByOrderValueAovResponse,
	type DynamicCommissionByOrderValueAovRow,
} from "./api";

export function useDynamicCommissionByOrderValueAovList(): UseQueryResult<ListDynamicCommissionByOrderValueAovResponse, Error> {
	return useQuery({
		queryKey: dynamicCommissionByOrderValueAovQueryKeys.list(),
		queryFn: list,
	});
}

export function useDynamicCommissionByOrderValueAovCreate(): UseMutationResult<DynamicCommissionByOrderValueAovRow, Error, CreateDynamicCommissionByOrderValueAovBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dynamicCommissionByOrderValueAovQueryKeys.all });
		},
	});
}

export function useDynamicCommissionByOrderValueAovDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: dynamicCommissionByOrderValueAovQueryKeys.all });
		},
	});
}
